import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog/dialog-ref';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-certificate-login',
  templateUrl: './certificate-login.component.html',
  styleUrls: ['./certificate-login.component.scss']
})
export class CertificateLoginComponent implements OnInit {
 dialogRef: MatDialogRef<any>;
  constructor(
    private fb: FormBuilder,
    public router: Router,
    public umsService: UmsService,
    private elRef: ElementRef,
    private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,

   ) { }
   public showPassword: boolean;
   CertLoginForm: FormGroup;
  ngOnInit(): void {
    this.umsService.setUserType('old');
    console.log('in certificate i set old');
    const the = localStorage.getItem('theme') ? localStorage.getItem('theme') : '';
    if (the.length <= 0){
      this.theme('blue');
    }else{
      this.theme(the);
    }
    this.CertLoginForm = this.fb.group({
      LoginName: ['', [Validators.required, Validators.minLength(6)]],
      LoginPswd: ['', [Validators.required, Validators.minLength(8)]]
      });
  }

  theme(i){
    if (i === 'white'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'gray');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'gray');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'gray');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'gray');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'black');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'black');
      localStorage.setItem('theme', i);
    }else if (i === 'yellow'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', '#d9c8a5');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--dark-border', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--main-content-title', '#ffab00');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', '#ffb10f');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', '#f0d6a1');
      localStorage.setItem('theme', i);
    }else if (i === 'red'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'red');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'red');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'red');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'red');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'red');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'red');
      localStorage.setItem('theme', i);
    }else if (i === 'green'){
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', 'green');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', 'white');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'green');
      this.elRef.nativeElement.style.setProperty('--dark-border', 'green');
      this.elRef.nativeElement.style.setProperty('--main-content-title', 'green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', 'green');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', 'green');
      localStorage.setItem('theme', i);
    }else{
      this.elRef.nativeElement.style.setProperty('--primary-gradent-one', '#0c1d78');
      this.elRef.nativeElement.style.setProperty('--primary-gradent-two', '#1b3ad4');
      this.elRef.nativeElement.style.setProperty('--primary-bg-color', '#0c1d78');
      this.elRef.nativeElement.style.setProperty('--dark-border', '#0c1d78');
      this.elRef.nativeElement.style.setProperty('--main-content-title', '#0c1d78');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1', '#7787bc');
      this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2', '#8f9cc0');
      localStorage.setItem('theme', i);
    }
   }


   Login()
   {
     // tslint:disable-next-line:prefer-const
     let payload = this.CertLoginForm.value;
     if(payload.LoginName == '' || payload.LoginPswd == ''){
       this.CertLoginForm.get('LoginName').markAsTouched();
       this.CertLoginForm.get('LoginPswd').markAsTouched();
       return;
     }
     else {
       this.onLogin();
     }
   }
 
  

   onLogin(){
    this.spinner.show();
    sessionStorage.clear();
    localStorage.clear();
     let payload = this.CertLoginForm.value;
     sessionStorage.setItem('LoginName',this.CertLoginForm.value.LoginName);
     this.umsService.login(payload).subscribe(res => {
      this.spinner.hide();
      if(res.status == false)
      {
       // let data = {}
       // data['message'] = res.message
       // data['title'] = 'Information'
       // data['icon'] = 'fas fa-check'
       // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        alert(res.message);
       //  this.umsService.openSnackbar('No Data');
      }
      sessionStorage.setItem('loginId', res.data[0].id);
       if (res.status)
       {
       localStorage.setItem('user', 'student');
       sessionStorage.setItem('StudentRGID', res.data[0].id);
       sessionStorage.setItem('session', res.projectPharam.SnNo);
       localStorage.setItem('headerlist', JSON.stringify(res));
       sessionStorage.setItem('token', res.token);
       this.umsService.setUserType('old');
      //  var link = document.createElement('a');
      //  link.setAttribute("href","/OpenAddmission");
      //  link.click();
      //  this.redirect('OpenAddmission');
       var link = document.createElement('a');
       link.setAttribute("href", "/home");
       link.click()
       }
       else if(res.status == false)
       {
        // let data = {}
        // data['message'] = res.message
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
         alert(res.message);
        //  this.umsService.openSnackbar('No Data');
       }
 
   },(ERROR: HttpErrorResponse) => {
    this.spinner.hide();
    alert(ERROR.error.message);
 });
 }

 redirect(to): void {
  this.router.navigate([to]);
}


SignUp(){
  this.redirect('student-registration');
}

 ForgotPass() {
    this.redirect('forgot-password');
  }

}
